export const CLIENT_INFO_HEADER_TITLE_FALLBACK = "Client information";
export const CLIENT_INFO_HEADER_TITLE = "%appointmentType with %visitorName";
